import { render } from "./DigitalView.vue?vue&type=template&id=372f14af&scoped=true"
import script from "./DigitalView.vue?vue&type=script&lang=js"
export * from "./DigitalView.vue?vue&type=script&lang=js"

import "./DigitalView.vue?vue&type=style&index=0&id=372f14af&lang=scss&scoped=true"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372f14af"]])

export default __exports__